module.exports = __webpack_public_path__ + "media/entities/2104-4265f4de.png";